import { tableConstantsFactory } from './tableConstantsFactory';
export default tableConstantsFactory('ORGANIZATION');